import styled from 'styled-components';

export const AdvantagesWrapper = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    column-gap: 10px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #1d201f;
    margin-bottom: 5px;
  }

  li:last-child {
    margin-bottom: 0;
  }

  li::before {
    content: url('/checkmark-outline.svg');
    width: 30px;
    height: 30px;
  }

  &.loading {
    li {
      margin-bottom: 14px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    li:before {
      display: none;
    }
  }
`;
